import { EnvironmentState } from 'store/slices/environment/slice';

export const ENVIRONMENT: EnvironmentState = {
  REACT_APP_BASE_URL: '/',
  REACT_APP_HOST: 'www.tecmasolutions.com',
  REACT_APP_NAME: 'myHome',
  REACT_APP_WEB_PROTOCOL: 'https://',
  REACT_APP_VERSION: '$npm_package_version',
  REACT_APP_APOLLO_URI: 'https://api-staging.tecmasolutions.com/biz-tecma-dev1/graphql',
  REACT_APP_API_URI: '/i18n',
  REACT_APP_PROJECT_API_BASE_URL: 'https://api-staging.tecmasolutions.com/biz-tecma-dev1/project/v2',
  REACT_APP_BUCKET_BASEURL: 'https://objectstorage.eu-frankfurt-1.oraclecloud.com/n/fronf8xprl08/b/tecma-assets-coll/o',
  REACT_APP_AWS_API_URI: 'https://f0hyff4p59.execute-api.eu-central-1.amazonaws.com/v1',
  REACT_APP_CLIENT_API_REST_URI: 'https://api-staging.tecmasolutions.com/biz-tecma-dev1/asset/v1',
  REACT_APP_TOKEN_EXPIRATION_THRESHOLD: '10000',
  REACT_APP_PUBLIC_URL: '/',
  NODE_ENV: 'development',
  REACT_APP_NAMESPACE: 'biz-tecma-dev1',
  REACT_APP_AWS_TOKEN: 'PAgkzutTbs1erM7RBBgc51an5k5wnBzt7FLZIDLI',
  REACT_APP_ASSET_API_REST_URI: 'https://api-staging.tecmasolutions.com/biz-tecma-dev1/asset',
  REACT_APP_PRODUCT_CONFIGURATION_API_REST_URI: 'https://api-staging.tecmasolutions.com/biz-tecma-dev1/product-configuration/api',
  REACT_APP_DISABLE_SEND_REQUEST_FLOW: false,
};

export const setEnvironment = (environment: EnvironmentState) => {
  Object.assign(ENVIRONMENT, environment);
};
